import React from "react"
import types from "prop-types"
import { RemoveButton } from "shared/buttons"
import { AccessLevelSelect } from "shared/selects"
import ItemRow from "shared/ItemRow"

const SelectedGroups = ({
  groups, removeGroup, setGroupAccessLevel = null, workflowData = [], selectLabel = "",
}) => {
  if (groups.length === 0) {
    return <div className="ml-4">No Selected Group</div>
  }

  const selectedAccessLevel = (groupId) => workflowData.find((group) => group.id === groupId).access_level

  return (
    groups.map((group) => (
      <ItemRow
        key={group.id}
        className="relative"
        itemRowHeaderControls={(
          <RemoveButton className="mr-2" icon="close" onClick={() => removeGroup(group.id)} ariaLabel="remove user" />
        )}
        itemRowHeaderContent={(
          <>
            <div className="flex items-center">
              <span>{group.name}</span>
            </div>
            {
              setGroupAccessLevel && !!workflowData.length && (
                <AccessLevelSelect
                  onChange={(value) => setGroupAccessLevel(value, group.id)}
                  value={selectedAccessLevel(group.id)}
                  selectLabel={selectLabel}
                />
              )
            }
          </>
        )}
      />
    ))
  )
}

SelectedGroups.propTypes = {
  groups: types.arrayOf(types.object).isRequired,
  removeGroup: types.func.isRequired,
  setGroupAccessLevel: types.func,
  workflowData: types.arrayOf(types.object),
  selectLabel: types.string,
}

export default SelectedGroups
